import { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DOM from './login';
import * as globalActions from '../../core/global/globalActions';

class Login extends Component {
    constructor(props) {
        super(props);
        this.view = DOM;
    }

    componentWillMount() {
        /* const script = document.createElement('script');
        script.src = 'http://localhost/animate/stick.js';
        document.body.appendChild(script); */
        const { actions } = this.props;

        // set breadcrumb
        actions.setBreadcrumb([{ title: 'Login' }]);
    }

    componentDidMount() {

    }

    render() {
        return this.view();
    }
}

Login.propTypes = {
    actions: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                ...globalActions,
            },
            dispatch,
        ),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Login);
